export enum ESkuOrderType {
  SINGLE_ORDER = 'SINGLE_ORDER',
  MULTI_ORDER = 'MULTI_ORDER',
}
